import { useModalStore } from '@/store/modal';
import Modal from '../Modal';

const ModalCustomerValidation = () => {
  const closeModal = useModalStore((store) => store.closeModal);
  const urlValidation = useModalStore((store) => store.urlValidation);

  return (
    <Modal closeModal={closeModal}>
      <div className='max-w-1280 relative mx-auto box-border rounded-md border border-gray-200'>
        <iframe
          title='Ecommerce'
          scrolling='no'
          className='relative min-h-[calc(100vh-15px)] w-full overflow-y-hidden rounded-md'
          src={urlValidation}
        />
      </div>
    </Modal>
  );
};

export default ModalCustomerValidation;
